/**
 * This class is the base class for all Dimension resolvers.
 * It decides whether a Tag Key from an influx-API result is covered by it, and then humanizes the relevant tag values.
 * Has to be subclassed to be useful.
 */
class DimensionResolver {
  constructor() {
    this.prepared = false
  }

  /**
   * Checks whether this resolver is relevant for the current instance.
   * This is mostly used to deactivate resolvers for non-barn instances.
   * @return {boolean} True if this resolver is relevant for the current instance, false otherwise
   */
  static isRelevantForCurrentInstance() {
    throw new Error('Method not implemented.')
  }

  /**
   * Checks whether the given tagKey is covered by this DimensionResolver.
   * Can use the actual data point for further reference.
   * @param {String} tag The key of the tag.
   * @param {Object} dataPoint the data point for further reference
   * @returns {Promise<boolean>} True if this resolver can resolve the tags of the given tag key, false otherwise
   */

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async doesTagKeyMatch(tag, dataPoint, query) {
    return false
  }

  /**
   * Prepares the resolver. This entails any loading that might be necessary depending on the actual resolving needs.
   * @returns {Promise<void>}
   */
  async prepareResolver() {
    if (this.prepared) return
    this.prepared = true
  }

  /**
   * This method tries to resolve the actual tag value. It should take the value, and return a human-readable version
   * (e.g. resolve a database id to an actual name, etc.)
   * @param tagValue
   * @returns {Promise<*>}
   */
  async humanizeTagValue(tagValue) {
    return tagValue
  }
}

export default DimensionResolver
